export default __webpack_public_path__ + "static/media/SmartFormal2.d98fd440.jpg";